import download from "downloadjs"

// Matches the "PlatformMedia" dashboard entity in src/server/models/technical.common.js:
// accessId for image/video requests with no specific module to check access against
// (group/kpLogo branding, dashboard media, platform-wide documents).
export const PLATFORM_MEDIA_ACCESS_ID = 'm-T-PlatformMedia-e'

export function getFile({url='file', fileId, filename, password, language, groupModel, accessId}){
    fetch(`${window.location.origin}/${url}Download`, {
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true
        },
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({context: {id: fileId, password, language, groupModelId: groupModel && groupModel.id, accessId}})
    })
    .then(resp => {
        return resp.blob()
    })
    .then(blob => download(blob, filename))
}
